import React, { Component } from 'react';
import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import { SCREEN_ID_ADMIN_FINANCE_MERCHANTS } from 'client/constants/screenIds';
import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrH1 from 'client/components/SrH1';
import SrPage from 'client/components/SrPage';
import SrDataTableMerchants from 'client/components/financeAdmin/SrDataTableMerchants';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_FINANCE_MERCHANTS)
@withScrollToTop
class FinancesMerchantsPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Finances - Merchants | Sunroom Rentals',
  })

  render() {
    return (
      <SrPage
        navbarProps={{
          redirectLogoTo: '/admin',
          backButtonLink: '/admin',
        }}
      >
        <div className='width-90'>
          <SrH1>merchants</SrH1>
          <SrDataTableMerchants />
        </div>
      </SrPage>
    );
  }
}

FinancesMerchantsPage.displayName = 'FinancesMerchantsPage';

export default FinancesMerchantsPage;
